(() => {
  'use strict';

  const media = {
    coaching: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-user-personal-training.jpg?v=1789665028',
    training: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mbf-user-training-plans.jpg?v=1789665041',
    founder: 'https://cdn.shopify.com/s/files/1/0738/4029/6194/files/mj-paknahad-original-portrait.jpg?v=1789563788&width=1200'
  };

  const ownScript = document.currentScript || Array.from(document.scripts).find(script => script.src.includes('mbf-user-media-fix.js'));
  const heroVideoUrl = ownScript ? new URL('mbf-hero-user-video.mp4', ownScript.src).href : '';
  const ptVideoUrl = heroVideoUrl;
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const swap = (img, url, options = {}) => {
    if (!img) return;
    const fit = options.fit || 'cover';
    const position = options.position || 'center';
    if (img.dataset.mbfUserMedia !== url) {
      img.src = url;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.dataset.mbfUserMedia = url;
    }
    img.style.setProperty('object-fit', fit, 'important');
    img.style.setProperty('object-position', position, 'important');
    if (fit === 'contain') {
      img.style.setProperty('height', 'auto', 'important');
      img.style.setProperty('max-height', 'none', 'important');
    }
  };

  const ensureStyles = () => {
    if (document.getElementById('mbf-user-media-style')) return;
    const style = document.createElement('style');
    style.id = 'mbf-user-media-style';
    style.textContent = `
      .mh-hero{position:relative;isolation:isolate;min-height:clamp(620px,74vh,860px);display:flex;align-items:center;background:#09090b;overflow:hidden}
      .mh-hero__user-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:62% center;z-index:0;background:#09090b}
      .mh-hero__video-shade{position:absolute;inset:0;z-index:1;pointer-events:none;background:linear-gradient(90deg,rgba(5,5,7,.94) 0%,rgba(5,5,7,.76) 38%,rgba(5,5,7,.42) 68%,rgba(5,5,7,.26) 100%)}
      .mh-hero:after{z-index:2}.mh-hero .mh-hero__in{position:relative;z-index:3}
      .ptl-hero__visual{position:relative;overflow:hidden;background:#08090b}
      .ptl-hero__visual .mbf-user-pt-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center center;z-index:1;background:#08090b;border-radius:inherit}
      .ptl-hero__visual .ptl-hero__mark{position:absolute;z-index:3}
      @media(max-width:980px){.mh-hero__video-shade{background:linear-gradient(90deg,rgba(5,5,7,.92) 0%,rgba(5,5,7,.68) 55%,rgba(5,5,7,.38) 100%)}}
      @media(max-width:560px){
        .mh-hero{min-height:620px;padding:82px 0 70px}.mh-hero__user-video{object-position:58% center}.mh-hero__video-shade{background:linear-gradient(180deg,rgba(5,5,7,.50) 0%,rgba(5,5,7,.72) 40%,rgba(5,5,7,.94) 100%)}
        .ptl-hero__visual .mbf-user-pt-video{object-position:center center}
      }
    `;
    document.head.appendChild(style);
  };

  const configureVideo = (video, src, poster) => {
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';
    video.tabIndex = -1;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    if (poster) video.poster = poster;
    let source = video.querySelector('source');
    if (!source) {
      source = document.createElement('source');
      video.appendChild(source);
    }
    if (source.src !== src) {
      source.src = src;
      source.type = 'video/mp4';
      video.load();
    }
    if (!reduceMotion) {
      video.autoplay = true;
      video.setAttribute('autoplay', '');
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    }
  };

  const ensureHeroVideo = () => {
    const hero = document.querySelector('.mh-hero');
    if (!hero || !heroVideoUrl) return;
    ensureStyles();
    let video = hero.querySelector('.mh-hero__user-video');
    if (!video) {
      video = document.createElement('video');
      video.className = 'mh-hero__user-video';
      hero.insertBefore(video, hero.firstChild);
    }
    configureVideo(video, heroVideoUrl, media.founder);
    if (!hero.querySelector('.mh-hero__video-shade')) {
      const shade = document.createElement('div');
      shade.className = 'mh-hero__video-shade';
      shade.setAttribute('aria-hidden', 'true');
      hero.insertBefore(shade, video.nextSibling);
    }
  };

  const ensurePersonalTrainingVideo = () => {
    const wrap = document.querySelector('.ptl-hero__visual');
    if (!wrap || !ptVideoUrl) return;
    ensureStyles();
    const oldPremiumVideo = wrap.querySelector('.mbf-coach-video');
    if (oldPremiumVideo) oldPremiumVideo.remove();
    let video = wrap.querySelector('.mbf-user-pt-video');
    if (!video) {
      video = document.createElement('video');
      video.className = 'mbf-user-pt-video';
      wrap.appendChild(video);
    }
    configureVideo(video, ptVideoUrl, media.coaching);
  };

  const apply = (root = document) => {
    root.querySelectorAll('img[src*="mj-paknahad-original-portrait.jpg"]').forEach(img => swap(img, media.founder, { fit: 'contain', position: 'center top' }));
    root.querySelectorAll('img[src*="mbf-home-personal-training-premium.webp"]').forEach(img => swap(img, media.coaching));
    root.querySelectorAll('img[src*="mbf-home-training-plans-premium.webp"]').forEach(img => swap(img, media.training));
    root.querySelectorAll('.ptl-hero__visual img').forEach(img => swap(img, media.coaching));
    root.querySelectorAll('.mbf-story-grid article:nth-child(2) img').forEach(img => swap(img, media.coaching));
    root.querySelectorAll('.mbf-story-grid article:nth-child(3) img').forEach(img => swap(img, media.training));
    root.querySelectorAll('.ptl-service-card[data-mbf-service-key="training-schema"] img').forEach(img => swap(img, media.training));
    root.querySelectorAll('.tp-grid article:first-child img').forEach(img => swap(img, media.training));
    ensureHeroVideo();
    ensurePersonalTrainingVideo();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => apply(), { once: true });
  else apply();

  const observer = new MutationObserver(() => apply());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();